import React, { useState, useEffect, useReducer } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import {
  acceptedProjectProcess,
  addFileGasProject,
  addFileGasProjectSingle,
  getGasProjectFiles,
  getGppByGpId,
  getListProjectProcessEng,
  getUserBalance,
  resetGasProjectFlag,
  resetPackage,
  submitDesignStage,
  submitFirstSupervisionStage,
  updateGasProjectCheckList,
  updateGasProjectDetailsNew,
  updateGasProjectEngNew,
  updateProcessDefectStageNew,
  updateProcessExpertStageNew,
  updateProcessMapStageNew,
} from "store/actions"
import { getCurrentUser } from "helpers/service_helper"
import "./gasProjectEng.scss"

import {
  Table,
  Pagination,
  Input,
  Space,
  Button,
  Row,
  Col,
  Radio,
  Checkbox,
  Card,
  Flex,
  Typography,
  Tag,
  Segmented,
  Collapse,
  Tooltip,
} from "antd"
import {
  SearchOutlined,
  FilterOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  UserOutlined,
  TeamOutlined,
  ReloadOutlined,
  DownOutlined,
  UpOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  EditOutlined,
  CloseCircleOutlined,
  FileSearchOutlined,
  SettingOutlined,
} from "@ant-design/icons"
import { projectColumnsAnt } from "./ProjectColumnsAnt"
import { PersianDatePicker } from "components/Common/PersianDatePicker"
import { NumericInput } from "components/Common/NumericInput"
import Locations from "components/Common/Locations"

const { Search } = Input
const { Title, Text } = Typography

const ListGasProjectProcessEng = props => {
  const {
    lstProjectProcessEng,
    lstProjectProcessEngTotal,
    matches_sm,
    handleChangeExpand,
    expanded,
    loading,
    onGetListProjectProcessEng,
    openNotification,
    reload,
  } = props

  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = useState(10)
  const [pageIndex, setPageIndex] = useState(1)
  const [deliverEngineer, setDeliverEngineer] = useState("")
  const [filterCity, setFilterCity] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [filterColumn, setFilterColumn] = useState(["وضعیت"])
  const [showFilters, setShowFilters] = useState(false)

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      projectLevelEnum: 4,
    }
  )

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
  }

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false)
    } else {
      handleSearchGasProjectProcessEng("search")
    }
  }, [formInput.projectLevelEnum])

  useEffect(async () => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
  }, [errorMessage, props.success, props.error])

  useEffect(async () => {
    await handleSearchGasProjectProcessEng("pageIndex")
  }, [pageIndex, pageSize])

  useEffect(async () => {
    if (reload) {
      await handleSearchGasProjectProcessEng()
    }
  }, [reload])

  const handleSearchGasProjectProcessEng = async val => {
    let searchQuery = {
      ...formInput,
      page: val === "search" ? 1 : pageIndex,
      pageSize: val === "search" ? 10 : pageSize,
      fileNumber: formInput.fileNumber ? formInput.fileNumber : 0,
      solarDateDeliverEngineer: deliverEngineer?.persian
        ? deliverEngineer.persian
        : "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      landlordName: formInput.landlordName ? formInput.landlordName : "",
      executorName: formInput.executorName ? formInput.executorName : "",
    }
    onGetListProjectProcessEng(searchQuery)
  }

  const onChangeFilterColumn = e => {
    setFilterColumn(oldArray => oldArray?.filter(x => x !== e.target.value))
    localStorage.setItem("filterColumnGppStorage", JSON.stringify([]))
    if (e.target.checked) {
      setFilterColumn(oldArray => {
        let filter = [...oldArray, e.target.value]
        localStorage.setItem("filterColumnGppStorage", JSON.stringify(filter))
        return filter
      })
    }
  }

  useEffect(() => {
    const data = localStorage.getItem("filterColumnGppStorage")
    if (data !== null && data !== "#") {
      try {
        setFilterColumn(JSON.parse(data))
      } catch (e) {
        return console.error(e)
      }
    }
  }, [])

  // Status options with icons and colors
  const statusOptions = [
    { value: 4, label: "انتظار طراحی", icon: <ClockCircleOutlined />, color: "#faad14" },
    { value: 1, label: "طراحی تایید شده", icon: <CheckCircleOutlined />, color: "#52c41a" },
    { value: 5, label: "انتظار تایید نقشه", icon: <EditOutlined />, color: "#1890ff" },
    { value: 2, label: "نقشه تایید شده", icon: <CheckCircleOutlined />, color: "#52c41a" },
    { value: 3, label: "انتظار نقص/لیست نقص", icon: <FileSearchOutlined />, color: "#ff7a45" },
    { value: 0, label: "کنسل شده", icon: <CloseCircleOutlined />, color: "#ff4d4f" },
  ]

  const getStatusColor = (value) => {
    const status = statusOptions.find(s => s.value === value)
    return status?.color || "#667eea"
  }

  return (
    <div>
      {/* Status Selection */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          marginBottom: 16,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: matches_sm ? 12 : 16 }}
      >
        <Flex align="center" gap={8} style={{ marginBottom: 12 }}>
          <SettingOutlined style={{ fontSize: 16, color: "#667eea" }} />
          <Text strong>وضعیت پرونده</Text>
        </Flex>

        {matches_sm ? (
          // Mobile: Vertical Radio Group
          <Radio.Group
            name="projectLevelEnum"
            onChange={handleInput}
            value={formInput.projectLevelEnum}
            style={{ width: "100%" }}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              {statusOptions.map((option) => (
                <Radio.Button
                  key={option.value}
                  value={option.value}
                  className="status-radio-btn"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    borderRadius: 8,
                    height: 40,
                    lineHeight: "38px",
                    borderColor: formInput.projectLevelEnum === option.value ? option.color : "#d9d9d9",
                    color: formInput.projectLevelEnum === option.value ? option.color : "#666",
                    background: formInput.projectLevelEnum === option.value ? `${option.color}10` : "#fff",
                  }}
                >
                  <Flex align="center" justify="center" gap={6}>
                    {option.icon}
                    <span>{option.label}</span>
                  </Flex>
                </Radio.Button>
              ))}
            </Space>
          </Radio.Group>
        ) : (
          // Desktop: Horizontal Segmented-like Radio Group
          <Radio.Group
            name="projectLevelEnum"
            onChange={handleInput}
            value={formInput.projectLevelEnum}
            optionType="button"
            buttonStyle="solid"
          >
            <Flex wrap="wrap" gap={8}>
              {statusOptions.map((option) => (
                <Tooltip key={option.value} title={option.label}>
                  <Radio.Button
                    value={option.value}
                    className="status-radio-btn"
                    style={{
                      borderRadius: 8,
                      minWidth: 140,
                      textAlign: "center",
                      borderColor: formInput.projectLevelEnum === option.value ? option.color : "#d9d9d9",
                      color: formInput.projectLevelEnum === option.value ? "#fff" : "#666",
                      background: formInput.projectLevelEnum === option.value ? option.color : "#fff",
                    }}
                  >
                    <Flex align="center" justify="center" gap={6}>
                      {option.icon}
                      <span style={{ fontSize: 13 }}>{option.label}</span>
                    </Flex>
                  </Radio.Button>
                </Tooltip>
              ))}
            </Flex>
          </Radio.Group>
        )}
      </Card>

      {/* Filter Section */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          marginBottom: 16,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: matches_sm ? 12 : 16 }}
      >
        <Flex 
          align="center" 
          justify="space-between" 
          onClick={() => setShowFilters(!showFilters)}
          style={{ cursor: "pointer", marginBottom: showFilters ? 16 : 0 }}
        >
          <Flex align="center" gap={8}>
            <FilterOutlined style={{ fontSize: 16, color: "#667eea" }} />
            <Text strong>فیلترهای جستجو</Text>
          </Flex>
          <Button 
            type="text" 
            size="small"
            icon={showFilters ? <UpOutlined /> : <DownOutlined />}
          />
        </Flex>

        {showFilters && (
          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12} md={6}>
              <div style={{ marginBottom: 4 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  <CalendarOutlined style={{ marginLeft: 4 }} />
                  تاریخ تخصیص
                </Text>
              </div>
              <PersianDatePicker
                label=""
                setDefault={false}
                setPersianDate={setDeliverEngineer}
              />
            </Col>

            <Col xs={24} sm={12} md={6}>
              <div style={{ marginBottom: 4 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  <FileTextOutlined style={{ marginLeft: 4 }} />
                  شماره پرونده
                </Text>
              </div>
              <NumericInput
                style={{ width: "100%", borderRadius: 8 }}
                value={formInput.fileNumber}
                name="fileNumber"
                onChange={handleInput}
                placeholder="شماره پرونده"
              />
            </Col>

            <Col xs={24} sm={12} md={6}>
              <div style={{ marginBottom: 4 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  <UserOutlined style={{ marginLeft: 4 }} />
                  نام مالک
                </Text>
              </div>
              <Input
                name="landlordName"
                onChange={handleInput}
                placeholder="مالک"
                allowClear
                style={{ borderRadius: 8 }}
              />
            </Col>

            <Col xs={24} sm={12} md={6}>
              <div style={{ marginBottom: 4 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  <TeamOutlined style={{ marginLeft: 4 }} />
                  نام مجری
                </Text>
              </div>
              <Input
                name="executorName"
                onChange={handleInput}
                placeholder="مجری"
                allowClear
                style={{ borderRadius: 8 }}
              />
            </Col>

            <Col xs={24} sm={12} md={6}>
              <Flex align="center" gap={8} style={{ height: "100%", paddingTop: 20 }}>
                <Checkbox
                  checked={filterCity}
                  onChange={e => setFilterCity(e.target.checked)}
                >
                  <Text style={{ fontSize: 13 }}>
                    <EnvironmentOutlined style={{ marginLeft: 4 }} />
                    فیلتر شهر
                  </Text>
                </Checkbox>
              </Flex>
            </Col>

            {filterCity && (
              <Col xs={24} sm={24} md={12}>
                <div style={{ marginBottom: 4 }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    <EnvironmentOutlined style={{ marginLeft: 4 }} />
                    انتخاب شهر
                  </Text>
                </div>
                <Locations
                  setDataAddress={setDataAddress}
                  matches_sm={matches_sm}
                  isAccessCity={true}
                />
              </Col>
            )}

            <Col xs={24}>
              <Flex justify="flex-end" gap={8} style={{ marginTop: 8 }}>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  onClick={() => handleSearchGasProjectProcessEng("search")}
                  style={{
                    borderRadius: 8,
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    border: "none",
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                  }}
                >
                  جستجو
                </Button>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => handleSearchGasProjectProcessEng("search")}
                  style={{ borderRadius: 8 }}
                >
                  بازنشانی
                </Button>
              </Flex>
            </Col>
          </Row>
        )}

        {!showFilters && (
          <Flex gap={8} wrap="wrap" style={{ marginTop: 12 }}>
            <Input
              name="fileNumber"
              onChange={handleInput}
              placeholder="شماره پرونده"
              prefix={<FileTextOutlined style={{ color: "#bfbfbf" }} />}
              style={{ width: matches_sm ? "100%" : 150, borderRadius: 8 }}
              allowClear
            />
            <Input
              name="landlordName"
              onChange={handleInput}
              placeholder="نام مالک"
              prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
              style={{ width: matches_sm ? "100%" : 150, borderRadius: 8 }}
              allowClear
            />
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => handleSearchGasProjectProcessEng("search")}
              style={{
                borderRadius: 8,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
              }}
            >
              جستجو
            </Button>
          </Flex>
        )}
      </Card>

      {/* Results Summary */}
      <Flex 
        justify="space-between" 
        align="center" 
        style={{ marginBottom: 12 }}
        wrap="wrap"
        gap={8}
      >
        <Flex align="center" gap={8}>
          <Tag
            color="blue"
            style={{
              borderRadius: 20,
              padding: "4px 12px",
              fontSize: 13,
            }}
          >
            تعداد کل: {lstProjectProcessEngTotal || 0}
          </Tag>
          <Tag
            style={{
              borderRadius: 20,
              padding: "4px 12px",
              fontSize: 13,
              background: `${getStatusColor(formInput.projectLevelEnum)}15`,
              color: getStatusColor(formInput.projectLevelEnum),
              border: `1px solid ${getStatusColor(formInput.projectLevelEnum)}40`,
            }}
          >
            {statusOptions.find(s => s.value === formInput.projectLevelEnum)?.label}
          </Tag>
        </Flex>
        
        <Text type="secondary" style={{ fontSize: 12 }}>
          صفحه {pageIndex} از {Math.ceil((lstProjectProcessEngTotal || 0) / pageSize)}
        </Text>
      </Flex>

      {/* Data Table */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          overflow: "hidden",
        }}
        bodyStyle={{ padding: 0 }}
      >
        <Table
          loading={loading}
          size="small"
          pagination={false}
          scroll={{ x: 700 }}
          sticky
          columns={projectColumnsAnt({
            props,
            setErrorMessage,
            currentUser: getCurrentUser(),
            matches_sm,
            handleChangeExpand,
            expanded,
            pageIndex,
            pageSize,
            filterColumn,
            projectLevel: formInput.projectLevelEnum,
          })}
          rowClassName={(_r, i) => (i % 2 ? "table-row-odd" : "table-row-even")}
          rowKey={record => record.id}
          dataSource={lstProjectProcessEng}
          locale={{ emptyText: "موردی یافت نشد" }}
        />
      </Card>

      {/* Pagination */}
      <Flex 
        justify="center" 
        style={{ 
          marginTop: 16,
          padding: "12px 0",
        }}
      >
        <Pagination
          current={pageIndex}
          total={lstProjectProcessEngTotal}
          pageSize={pageSize}
          showSizeChanger
          showQuickJumper={!matches_sm}
          pageSizeOptions={["10", "20", "50", "100"]}
          onChange={(page, size) => {
            setPageIndex(page)
            setPageSize(size)
          }}
          style={{
            direction: "ltr",
          }}
        />
      </Flex>
    </div>
  )
}


const mapStateToProps = ({
  GasProjects,
  USERs,
  GasProjectProcesses,
  Engineers,
}) => ({
  lstProjectProcessEng: GasProjectProcesses.lstProjectProcessEng,
  lstProjectProcessEngTotal: GasProjectProcesses.lstProjectProcessEngTotal,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  lstGpp: GasProjectProcesses.lstGpp,
  currentIdGasProject: GasProjects.currentIdGasProject,
  error: GasProjectProcesses.error,
  errorGasProject: GasProjects.error,
  success: GasProjectProcesses.success,
  successGasProject: GasProjects.success,
  loading: GasProjectProcesses.loading,
  loadingGasProject: GasProjects.loading,
  userBalance: USERs.userBalance
})

const mapDispatchToProps = dispatch => ({
  onGetListProjectProcessEng: searchValue =>
    dispatch(getListProjectProcessEng(searchValue)),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onGetUserBalance: () => dispatch(getUserBalance()),
  onAddFileGasProject: attachData => dispatch(addFileGasProject(attachData)),
  onAddFileGasProjectSingle: attachData => dispatch(addFileGasProjectSingle(attachData)),
  onUpdateProcessExpertStageNew: process => dispatch(updateProcessExpertStageNew(process)),
  onUpdateProcessMapStageNew: process => dispatch(updateProcessMapStageNew(process)),
  onUpdateProcessDefectStageNew: process => dispatch(updateProcessDefectStageNew(process)),
  onResetPackage: gpId => dispatch(resetPackage(gpId)),
  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onUpdateGasProjectDetailsNew: process => dispatch(updateGasProjectDetailsNew(process)),
  onUpdateGasProjectEngNew: gasProject => dispatch(updateGasProjectEngNew(gasProject)),
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onSubmitDesignStage: process => dispatch(submitDesignStage(process)),
  onSubmitFirstSupervisionStage : process => dispatch(submitFirstSupervisionStage(process)),
  onUpdateGasProjectCheckList: process => dispatch(updateGasProjectCheckList(process)),
  onAcceptedProjectProcess: process => dispatch(acceptedProjectProcess(process)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ListGasProjectProcessEng))
